import React from 'react';
import { LetterProcessing } from 'api';
import { connect } from 'react-redux';
import { header } from 'constants/table';
import { Toastr } from 'modules/toastr';
import DataTable from 'components/data-table';
import { msg } from 'constants/message';
import { RowItemListHandleLetters } from 'modules/handle-letters/datatable/list';

class TongHop extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.data,
      trangThaiXuLyDon: 'DON_TRE_HAN_GIAI_QUYET',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      startDateValid: true,
      endDateValid: true,
      tableLoading: false,
    };
  }

  componentDidMount() {
    let data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
    this.setState({
      pageData: {
        number: data.page || 0,
        size: data.size || 10
      }
    }, () => {
      this.getListData();
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
    });
  }

  handleDelete(donId) {
    LetterProcessing.actions.deleteDon.request({
      id: donId
    }).then(res => {
      Toastr(msg.deleteLetterSucess, 'success');
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
      this.props.dispatch({
        type: 'DELETE_ITEM_DATALIST',
        key: 'listXLD',
        idKey: 'donId',
        id: donId
      });
      this.getListData();
    }).catch(err => {
      let Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
      Data.forEach(function (item) {
        Toastr(item.description, 'error');
      })
    });
  }

  // Note: ThuHoiDon
  handleThuHoi(donId) {
    LetterProcessing.actions.deleteDon.request({
      id: donId
    }).then(res => {
      Toastr(msg.thuHoiDon, 'success');
      this.getListData();
    });
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleChangeTrangThaiXuLyDon(e) {
    this.setState({
      trangThaiXuLyDon: e.target.value,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
    }, () => {
      this.getListData();
    })
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData();
  }

  getListData() {
    let params = {
      size: this.state.pageData.size,
      page: this.state.pageData.number
    };
    localStorage.setItem('xldData', JSON.stringify({...params}));
    if (this.props.routerName === 'dontrehanxulytaidonvi') {
      return LetterProcessing.actions.getListDonTreHanXuLy.request(params).then(res => {
        if (this.refs.listXLD) {
          let Data = [];
          if (res.data._embedded) {
            Data = res.data._embedded.dons,
              this.setState({
                pageData: res.data.page
              });
          } else {
            this.setState({
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              },
            });
          }
          this.setState({
            tableLoading: false,
          }, () => {
            this.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listXLD', data: Data });
          });
        }
      }).catch(err => {
        this.setState({
          tableLoading: false,
        });
      });
    } else if (this.props.routerName === 'dontrehanxulytaidiaban') {
      return LetterProcessing.actions.getListDonTreHanXuLyTaiDiaBan.request(params).then(res => {
        if (this.refs.listXLD) {
          let Data = [];
          if (res.data._embedded) {
            Data = res.data._embedded.dons,
              this.setState({
                pageData: res.data.page
              });
          } else {
            this.setState({
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              },
            });
          }
          this.setState({
            tableLoading: false,
          }, () => {
            this.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listXLD', data: Data });
          });
        }
      }).catch(err => {
        this.setState({
          tableLoading: false,
        });
      });
    } else if (this.props.routerName === 'dontrehangiaiquyettaidiaban') {
      return LetterProcessing.actions.getListDonTreHanGiaiQuyetTaiDiaBan.request(params).then(res => {
        if (this.refs.listXLD) {
          let Data = [];
          if (res.data._embedded) {
            Data = res.data._embedded.dons,
              this.setState({
                pageData: res.data.page
              });
          } else {
            this.setState({
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              },
            });
          }
          this.setState({
            tableLoading: false,
          }, () => {
            this.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listXLD', data: Data });
          });
        }
      }).catch(err => {
        this.setState({
          tableLoading: false,
        });
      });
    } else {
      return LetterProcessing.actions.getListDonTreHanGiaiQuyet.request(params).then(res => {
        if (this.refs.listXLD) {
          let Data = [];
          if (res.data._embedded) {
            Data = res.data._embedded.dons,
            this.setState({
              pageData: res.data.page
            });
          } else {
            this.setState({
              pageData: {
                number: 0,
                size: 10,
                totalElements: 0
              },
            });
          }
          this.setState({
            tableLoading: false,
          }, () => {
            this.props.dispatch({ type: 'UPDATE_DATALIST', key: 'listXLD', data: Data });
          });
        }
      }).catch(err => {
        this.setState({
          tableLoading: false,
        });
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== this.props.data) {
      this.setState({
        data: nextProps.data
      });
    }
  }

  componentWillUnmount() {
    let params = {
      size: 10,
      page: 0
    };
    localStorage.setItem('xldData', JSON.stringify({...params}));
  }

  render() {
    const donTreHanTaiDiaBan = (this.props.routerName === 'dontrehanxulytaidiaban' || this.props.routerName === 'dontrehangiaiquyettaidiaban') ? true : false;
    return (
      <div ref="listXLD">
        <div className="center reception-container">
          <div className="top-content">
          </div>
          <div className="bottom-content">
            <DataTable header={header.listXLD}
              dataList={this.state.data}
              pageData={this.state.pageData}
              hideButtonExport={true}
              parent={this}
              redux={this}
              tableLoading={this.state.tableLoading}>
              <RowItemListHandleLetters
                donTreHanTaiDiaBan={donTreHanTaiDiaBan}
                type={this.state.trangThaiXuLyDon}
                getListData={this.getListData.bind(this)} />
            </DataTable>
          </div>
        </div>
      </div>
    );
  }
}

TongHop.defaultProps = {
  data: []
}

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listXLD
  };
}

export default connect(bindStateToProps)(TongHop);


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/tong-hop/TongHop.jsx